import type {ReactNode} from "react";

import type {ISearchComboboxIconProps} from "../types/ISearchComboboxIconProps";

interface IProps extends ISearchComboboxIconProps {
    /** Frame size - the viewBox side and the default rendered size. */
    frameSize: number;
    children: ReactNode;
}

/**
 * Decorative SVG shell for the glyphs. Paths paint with `currentColor`, so the colour comes from
 * the surrounding CSS; the icons are always hidden from assistive technology.
 */
export const SearchComboboxSvgIcon = (props: IProps) => {
    const {frameSize, size = frameSize, className, dataTestId, children} = props;

    return (
        <svg
            className={className}
            data-testid={dataTestId}
            width={size}
            height={size}
            viewBox={`0 0 ${frameSize} ${frameSize}`}
            fill="none"
            aria-hidden="true"
            focusable="false"
        >
            {children}
        </svg>
    );
};
import type {ReactNode} from "react";

import type {ISearchComboboxIconProps} from "../types/ISearchComboboxIconProps";

interface IProps extends ISearchComboboxIconProps {
    /** Frame size - the viewBox side and the default rendered size. */
    frameSize: number;
    children: ReactNode;
}

/**
 * Decorative SVG shell for the glyphs. Paths paint with `currentColor`, so the colour comes from
 * the surrounding CSS; the icons are always hidden from assistive technology.
 */
export const SearchComboboxSvgIcon = (props: IProps) => {
    const {frameSize, size = frameSize, className, dataTestId, children} = props;

    return (
        <svg
            className={className}
            data-testid={dataTestId}
            width={size}
            height={size}
            viewBox={`0 0 ${frameSize} ${frameSize}`}
            fill="none"
            aria-hidden="true"
            focusable="false"
        >
            {children}
        </svg>
    );
};
